module.exports = require('../abstract').extend
  template: require('./index.pug')

  props:
    payload:    { default: null }
    ignoreEsc:  { default: false }

  computed:

    popupKey: ->
      @payload.key

    popupName: ->
      @payload.name

    popupId: ->
      @payload.id

  methods:

    hide: ->
      @.$store.dispatch('popups/hide', @payload)

    emitPopupEvent: (name, payload = {}) ->
      @.$popups.$emit('custom', {
        key:      @popupKey
        name:     @popupName
        id:       @popupId
        event:    name
        payload:  payload
      })

  created: ->
    @.$store.dispatch('popups/ignoreEsc', @payload) if @ignoreEsc == true




// WEBPACK FOOTER //
// ./assets/js/shared_frontend/components/popup/index.coffee